<bn-loading-overlay></bn-loading-overlay>
<ng-template #carregando>
  <div class="loading-pesquisa">
    <i class="bn-loading"></i>
  </div>
</ng-template>

<h5>Solicitações de Honra</h5>
<div *ngIf="podeEscolherAgente && janelaEnvioAtual"> 
  <small class="text-muted">Data de processamento (janela corrente): {{janelaEnvioAtual.dataInicioProcessamento | date:'dd/MM/yyyy'}}</small> 
</div>
<div class="container" *ngIf="valoresPesquisaForm; else carregando">
  <form [formGroup]="pesquisaForm" class="mt-3 mx-auto" (keyup.enter)="focusableSubmit.click()">
    <div class="mb-3 row">
      <div class="col">
        <h3>Filtros de pesquisa</h3>
      </div>
      <div class="col-auto">
        <button class="btn btn-primary no-margin" type="button" [routerLink]="['/solicitacoes-honra/cadastro']" placement="bottom"
          ngbTooltip="Tela para cadastro de solicitação de honra." [disabled]="!podeEnviarSH"><i class="fa fa-file-signature">
          </i> Solicitação de honra</button>
      </div>      
      <div class="col-auto">
        <button type="button" class="btn btn-light" (click)="limpar()">Limpar</button>
      </div>
      <div class="col-auto">
        <button #focusableSubmit type="button" class="btn btn-success no-margin" (keydown.enter)="buscar(false, true)" (click)="buscar(false, true)"
        [disabled]="!pesquisaForm.valid">Pesquisar</button>
      </div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-7">
        <label class="form-label" for="agenteFinanceiro">Agente Financeiro:</label>
        <select  id="agenteFinanceiro" class="form-select" [compareWith]="compararPorId" formControlName="agenteFinanceiro">
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let item of agentesFinanceiros"
                  [ngValue]="item">{{ item.nome }}</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label" for="janela">Janela de envio: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Nome da janela de envio em formato Mês/Ano (MM/AAAA)"></i></label>
        <input type="text" class="form-control" bnMask="MESANO" formControlName="janela">
      </div>
      <div class="bn-form-group col-md-2"> 
        <label class="form-label">Id. sol. honra: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Identificador da solicitação de honra"></i>
        </label>
        <input type="text" class="form-control" formControlName="idSolicitacaoHonra">
      </div>
    </div>

    <div class="row">
      <div class="bn-form-group col-md-4">
        <label class="form-label" for="estado">Estado:</label>
        <select id="estado" class="form-select" [compareWith]="compararPorId" formControlName="estado">
          <option [ngValue]=null>Todos</option>
          <option *ngFor="let item of estados"
                  [ngValue]="item">{{item.nome }}</option>
        </select>
      </div>

      <div class="bn-form-group  col-md-3">
        <label class="form-label" for="sistema">Sistema: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
              ngbTooltip="Sistema do contrato, constante dos Boletos de Cobrança enviados pelo BNDES, ou Crédito Livre."></i>
        </label>
        <select id="sistema" class="form-select" [compareWith]="compararPorId" formControlName="sistema">
          <option value=''>Todos</option>
          <option value='CL'>Crédito Livre</option>
          <option value='15'>15 - Contratos FINAME</option>
          <option value='89'>89 - Contratos BNDES</option>
        </select>
      </div>
      <div class="bn-form-group col-md-3">
        <label class="form-label">Id. externo operação: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Identificador da operação informado pelo Agente Financeiro em operações Crédito Livre."></i>
        </label>
        <input type="text" class="form-control" formControlName="idExternoOperacao">
      </div>

      <div class="bn-form-group col-md-2">
        <label class="form-label">Contrato: <i class="fa fa-question-circle help-subtitulo" placement="bottom"
          ngbTooltip="Número do contrato, constante dos Boletos de Cobrança enviados pelo BNDES."></i>
        </label>
        <input type="text" class="form-control" formControlName="contrato">
      </div>
    </div>
  </form>
  
</div>

<app-solicitacao-honra-listagem
  [solicitacoesHonra]="solicitacoesHonra"
  [atributosPaginacao]="atributosPaginacaoComponenteListagem"
  [ehAgenteFinanceiro]="ehAgenteFinanceiro"
  *ngIf="pesquisado"
  [hidden]="esconderPesquisa"
  (aoMudarPagina)="mudancaPagina($event)"
  (aoExportarSolicitacoes)="preparaSolicitacoesExportar()"
  >
</app-solicitacao-honra-listagem>